import * as $ from 'jquery';

/**
 * SubmitHelper
 *
 * @author Felix König <f.koenig@andersundsehr.com>
 */
export default class SubmitHelper {
  /**
   * Public function to init class
   */
  constructor() {
    const $submitSelect: JQuery<HTMLFormElement> = $('.js-submit-select');
    $submitSelect.on('change', function () {
      this.form.submit();
    });

    const $submitInput: JQuery<HTMLFormElement> = $('.js-submit-input');
    $submitInput.on('change', function () {
      this.form.submit();
    });
  }
}
